/**
* 子表触发条件
* @author chenyaobang<chenyaobang@inspur.com>
 */

import { ExecutingDataStatus } from "./ExecutingDataStatus";
import { RequestChildElement } from "./RequestChildElement";

export class ChildTriggerInfo  {
    RequestChildElements: string[];
    GetExecutingDataStatus: ExecutingDataStatus;
}

export class ChildValTriggerInfo {
    Code: string;
    Value: ChildTriggerInfo;
}

export class ChildDtmTriggerInfo {
    Code: string;
    Value: ChildTriggerInfo;
}
